import React, { useEffect, useState } from "react"
import { Card, Form, Typography, Descriptions, Table, Skeleton } from "antd"

const { Title, Text } = Typography

const DesignFormReport = props => {
  const { model, lstGasProjectFiles } = props

  const [designPlanUrl, setDesignPlanUrl] = useState(null)

  useEffect(() => {
    if (model) {
      const date1 = new Date(model.gasProject.julianRegisterDate)
      const date2 = new Date("2024-08-24")
      const checkDate = date1 > date2

      const designPlanFile = checkDate
        ? lstGasProjectFiles.find(x => x.fileTypeEnum === 11)
        : lstGasProjectFiles.find(x => x.fileTypeEnum === 2)

      if (designPlanFile) {
        const url = `${process.env.REACT_APP_API_URL}/Users/GetPhysicalFileS3Liara?path=Upload/GasProjects/${designPlanFile.folderName}/${designPlanFile.fileName}&fileNumber=${model.gasProject.fileNumber}`
        setDesignPlanUrl(url)
      }
    }
  }, [model])

  const equipmentMap = [
    { key: "gCom", title: "اجاق گاز" },
    { key: "hitter", title: "بخاری" },
    { key: "whFl", title: "آبگرمکن زمینی" },
    { key: "whWa", title: "آبگرمکن دیواری" },
    { key: "whWaFan", title: "آبگرمکن دیواری فن‌دار" },
    { key: "pFa", title: "پکیج" },
    { key: "burner", title: "مشعل" },
    { key: "rNorm", title: "کباب‌پز" },
    { key: "rCom", title: "پلوپز تجاری" },
    { key: "gOvn", title: "اجاق گاز تجاری" },
  ]

  const getEquipmentDataSource = detail => {
    if (!detail) return []

    return equipmentMap
      .map((item, index) => {
        const count = Number(detail[`${item.key}Count`] ?? 0)
        const usage = detail[`${item.key}Usage`] ?? 0

        return {
          key: String(index + 1),
          title: item.title,
          count,
          usage,
        }
      })
      .filter(item => item.count > 0)
  }

  console.log("model", { ...model })

  return model ? (
    <Form layout="vertical" component={false}>
      <Card
        title={
          <Title style={{ fontFamily: "b titr" }} level={4}>
            مشخصات پرونده
          </Title>
        }
        className="mb-4"
      >
        <Descriptions size="small" column={{ xs: 1, sm: 2 }}  bordered>
          <Descriptions.Item label="نام مالک/مالکین/حقوقی">
            {model.gasProject.landlordName}
          </Descriptions.Item>
          <Descriptions.Item label="شماره پرونده">
            {model.gasProject.fileNumber}
          </Descriptions.Item>
          <Descriptions.Item label="کد پستی">
            {model.gasProject.postalCode}
          </Descriptions.Item>

          <Descriptions.Item label="تاریخ ثبت">
            {model.gasProject.solarRegisterDate}
          </Descriptions.Item>

          <Descriptions.Item label="آدرس">
            {model.gasProject.address}
          </Descriptions.Item>

          <Descriptions.Item label="گروه بندی ساختمان">
            {model.groupTypeName}
          </Descriptions.Item>

          <Descriptions.Item label="طبقه">
            {model.gasProject?.floorNumber}
          </Descriptions.Item>

          <Descriptions.Item label="نوع آپارتمان درگروه بندی">
            {model.unitTypeName}
          </Descriptions.Item>

          <Descriptions.Item label="تعداد واحد">
            {model.gasProject.unitNumber}
          </Descriptions.Item>

          <Descriptions.Item label="کاربری">
            {model.buildingTypeName}
          </Descriptions.Item>

          <Descriptions.Item label="شماره واحد">
            {model.gasProject.unitDes}
          </Descriptions.Item>

          <Descriptions.Item label="جهت جغرافیایی">
            {model.geoTypeName}
          </Descriptions.Item>

          <Descriptions.Item label="نوع لوله کشی">
            {model?.pipingTypeName}
          </Descriptions.Item>
          <Descriptions.Item label="محل کنتور">
            {model.gasProjectDetail?.locationGasMeter}
          </Descriptions.Item>

          <Descriptions.Item label="نیاز به رضایت نامه محضری">
            {model.gasProjectDetail?.consent ? "دارد" : "ندارد"}
          </Descriptions.Item>

          <Descriptions.Item label="زیربنای حرارتی">
            {model.gasProject.area}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card
        title={
          <Title style={{ fontFamily: "b titr" }} level={4}>
            تجهیزات ایمنی و مشخصات دریچه ها
          </Title>
        }
        className="mb-4"
      >
        <Descriptions size="small" column={{ xs: 1, sm: 2 }} bordered>
          <Descriptions.Item label="نیاز به شیر قطع کن فرعی">
            {model.gasProjectDetail?.needSubCutter
              ? model.gasProjectDetail?.needSubCutter
              : "ندارد"}
          </Descriptions.Item>

          <Descriptions.Item label="دریچه تامین هوا">
            {model.gasProjectDetail?.desWindowsSealing
              ? model.gasProjectDetail?.desWindowsSealing
              : "ندارد"}
          </Descriptions.Item>
          <Descriptions.Item label="مشخصات اگزاست">
            {model.gasProjectDetail?.veDimension}
          </Descriptions.Item>

          <Descriptions.Item label="مشخصات دودکش">
            {model.gasProjectDetail?.chDiameter}
          </Descriptions.Item>

          <Descriptions.Item label="درزبندی پنجره ها">
            {model.gasProjectDetail?.windowsSealingStatus}
          </Descriptions.Item>
          <Descriptions.Item label="آشکار ساز مونوکسید کربن">
            {model.gasProjectDetail?.gasCutOffExt ? "دارد" : "ندارد"}
          </Descriptions.Item>

          <Descriptions.Item label="شیرخودکارقطع گازدرزلزله">
            {model.gasProjectDetail?.autoGasCutOff ? "دارد" : "ندارد"}
          </Descriptions.Item>
          <Descriptions.Item label="آشکار ساز طبیعی">
            {model.gasProjectDetail?.gasLeakWarning ? "دارد" : "ندارد"}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card
        title={
          <Title style={{ fontFamily: "b titr" }} level={4}>
            تجهیزات مصرفی
          </Title>
        }
        className="mb-4"
      >
        <Table
          columns={[
            { title: "مصرف‌کننده", dataIndex: "title", key: "title" },
            { title: "تعداد", dataIndex: "count", key: "count" },
            { title: "مصرف", dataIndex: "usage", key: "usage" },
          ]}
          size="small"
          dataSource={getEquipmentDataSource(model.gasProjectDetail)}
          pagination={false}
          bordered
        />
        <Descriptions size="small" column={{ xs: 1, sm: 2 }}  bordered>
          <Descriptions.Item label="جمع تعداد">
            {model.gasProjectDetail?.totalCount}
          </Descriptions.Item>

          <Descriptions.Item label="جمع مصرف">
            {model.gasProjectDetail?.totalUsage}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      <Card
        title={
          <Title style={{ fontFamily: "b titr" }} level={4}>توضیحات کارشناس
          </Title>
        }
        className="mb-4"
      >
        <Descriptions size="small" column={1} bordered>

      <Descriptions.Item >
        {model.gasProjectDetail?.description?model.gasProjectDetail?.description:"در الزامات توضیحاتی وارد نشده است."}
      </Descriptions.Item>
</Descriptions>
</Card>
      {designPlanUrl ? (
        <Card
          title={
            <Title style={{ fontFamily: "b titr" }} level={5}>
              نقشه طراحی
            </Title>
          }
          className="mb-4"
          style={{ textAlign: "center" }}
        >
          <img
            src={designPlanUrl}
            alt="Design Plan"
            style={{ maxWidth: "100%", maxHeight: 600, borderRadius: 8 }}
          />
        </Card>
      ) : (
        <Skeleton.Image active />
      )}
    </Form>
  ) : (
    <>خطا در بارگذاری </>
  )
}

export default DesignFormReport
